import { inject, Injectable } from '@angular/core';
import { HrtApiService } from '../hrt-api/hrt-api.service';
import { Observable } from 'rxjs';
import {
  MlValidationFeedback,
  MlValidationFeedbackPatch,
  MlValidationFeedbacksPage,
  MlValidationFeedbackTableQuery,
  Pagination,
} from '@shared/models';

export const MlValidationFeedbacksBaseUrl = 'ml-validation-feedbacks';

@Injectable({ providedIn: 'root' })
export class MlValidationFeedbacksApiService {
  private readonly api = inject(HrtApiService);

  getMlValidationFeedbacks(
    { page, pageSize }: Pagination,
    tableQuery?: MlValidationFeedbackTableQuery
  ): Observable<MlValidationFeedbacksPage> {
    // The backend names the page parameter `pageNumber`.
    return this.api.get<MlValidationFeedbacksPage>(MlValidationFeedbacksBaseUrl, {
      params: { pageNumber: page, pageSize, ...(tableQuery ? { tableQuery: JSON.stringify(tableQuery) } : {}) },
    });
  }

  saveMlValidationFeedback(payload: MlValidationFeedbackPatch): Observable<MlValidationFeedback> {
    const { id, ...changes } = payload;
    return this.api.patch<MlValidationFeedback>(`${MlValidationFeedbacksBaseUrl}/${id}`, changes);
  }
}
